import React from "react"
import styled, { css } from "styled-components"

import Disclosures from "../global/disclosures"

const size = {
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const DisclosureWrapper = styled.div`
  background-color: #edf2f7;
  padding: 24px 0;

  div {
    max-width: 1248px;
    padding: 0 48px;
    margin: 0 auto;
    ${below.mobile`
  padding: 0 24px;
  `}

    p {
      font-family: "Playfair Display", serif !important;
      font-weight: 400;
      letter-spacing: 0.01em;
      color: #000;
      font-size: 12px;
      line-height: 20px;
      margin: 0;
      padding: 0;
      ${below.mobile`
      font-size: 10px;
      line-height: 16px;
  `}
      a {
        color: var(--pacific-blue);
      }
    }
  }
`

const MBDisclosure = props => (
  <DisclosureWrapper>
    <div>
      <Disclosures disclosure={props.disclosure} />
    </div>
  </DisclosureWrapper>
)

export default MBDisclosure
